import { Fragment } from "react";
import CelularWhatsApp from "../disparos/whatsapp/CelularWhatsApp";
import { preencherExemplo } from "./api";

// *negrito* do WhatsApp e "> citação" só pra prévia.
function linha(t, i) {
  const citacao = t.startsWith("> ");
  const partes = (citacao ? t.slice(2) : t).split(/(\*[^*\n]+\*)/g).map((p, j) =>
    /^\*[^*]+\*$/.test(p) ? <strong key={j}>{p.slice(1, -1)}</strong> : <Fragment key={j}>{p}</Fragment>,
  );
  return (
    <span key={i} className={citacao ? "block border-l-2 border-[#8696a0] pl-2 text-[#54656f]" : "block min-h-[19px]"}>
      {partes}
    </span>
  );
}

/**
 * Celular com a conversa do WhatsApp mostrando a mensagem escolhida como o
 * cliente vê, com as variáveis trocadas por exemplos. `previa` =
 * {titulo, texto, prefixo?, botao?} — `prefixo` põe o "🤖 CLEO:" dos avisos
 * automáticos; `botao` é o botão de resposta dos modelos do WhatsApp oficial.
 */
export default function PreviaCelular({ nomeLoja, logo, previa }) {
  const texto = previa?.texto ? preencherExemplo(previa.texto) : "";
  const corpo = previa?.prefixo ? `🤖 *CLEO:*\n\n${texto}` : texto;
  return (
    <div className="space-y-3">
      <CelularWhatsApp nomeLoja={nomeLoja} logo={logo}>
        {corpo ? (
          <div className="relative max-w-[88%] drop-shadow-[0_1px_0.5px_rgba(11,20,26,0.13)]">
            <span className="absolute -left-[7px] top-0 h-0 w-0 border-r-[8px] border-t-[10px] border-r-transparent border-t-white" />
            <div className="rounded-lg rounded-tl-none bg-white px-2.5 pb-1 pt-1.5 text-[14px] leading-[19px] text-[#111b21]">
              <div className="whitespace-pre-wrap break-words">{corpo.split("\n").map(linha)}</div>
              <p className="mt-0.5 text-right text-[11px] text-[#667781]">10:42</p>
            </div>
            {previa?.botao && (
              <div className="mt-1 rounded-lg bg-white px-2.5 py-2 text-center text-[14px] font-medium text-[#00a5f4]">
                {previa.botao}
              </div>
            )}
          </div>
        ) : (
          <p className="mx-auto mt-24 max-w-[220px] rounded-lg bg-white/90 px-3 py-2 text-center text-[12px] text-[#54656f] shadow-sm">
            Clique em <b>Ver no celular</b> em qualquer mensagem pra ver como ela chega.
          </p>
        )}
      </CelularWhatsApp>
      <p className="text-center text-xs text-muted-foreground">
        {previa?.titulo ? <>Prévia: <b>{previa.titulo}</b>. Os valores são exemplos.</> : "As mensagens criadas pela CLEO variam a cada conversa."}
      </p>
    </div>
  );
}
